import IWalletBase from "@/module/main/dto/financing-v3/IWalletBase";
import IAmount from "@/module/main/dto/IAmount";
import IWalletFinancingBase from "@/module/main/dto/financing-v3/IWalletFinancingBase";

export default class WalletBase implements IWalletBase
{
    public readonly amount?: IAmount;
    public readonly financing: IWalletFinancingBase;

    constructor(props: IWalletBase)
    {
        this.amount = props.amount;
        this.financing = props.financing;
    }
}
